/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import Layout from '../containers/layout';
import VisualComposer from '../components/VisualComposer';
import HeaderPage from '../components/HeaderPage';
import WidgetCard from '../components/WidgetCard';
import useMatchMedia from '../hooks/match-media';
import Paragraph from '../components/Paragraph';
import { useSizeColsIsRoot } from '../hooks/archive-hooks';
import FeedByRelationship from '../containers/FeedRelationshipPageTemplate';
import FeedWithHighlight from '../containers/FeedWithHighlight';
// import Icon from '../components/Icons'; FEATURE WHATSAPP

/** UTILS  */
const parsePageData = (data) => {
  const {
    title,
    slug,
    subtitle,
    content,
    coverImage,
    coverImageMobile,
    widgetCard,
    contentAccordion,
    treeParent,
    root,
    newsFeedModularBlock,
    seoMetaTags
  } = data;
  const model = data.model.name;
  const treeChildren = treeParent && treeParent.treeChildren;
  return {
    coverImage,
    coverImageMobile,
    widgetCard,
    title,
    slug,
    subtitle,
    content,
    contentAccordion,
    treeParent,
    treeChildren,
    root,
    model,
    seoMetaTags,
    newsFeedModularBlock: newsFeedModularBlock[0] ? newsFeedModularBlock[0] : {}
  };
};

const parseFeedByRelationship = (data) => {
  let relatedNews = [];
  if (data.newsByTopic && data.newsByTopic.nodes) {
    relatedNews = data.newsByTopic.nodes;
  } else if (data.newsByCategory && data.newsByCategory.nodes) {
    relatedNews = data.newsByCategory.nodes;
  }

  const sampleNews = relatedNews[0] ? relatedNews[0] : {};

  let relatedBy = '';
  if (data.newsByTopic) {
    relatedBy = 'topic';
  } else if (data.newsByCategory) {
    relatedBy = 'category';
  }

  return {
    list: relatedNews,
    sampleNews,
    relatedBy
  };
};

/** COMPONENT */
const PageTemplate = ({ data, pageContext }) => {
  const [isMobile, setIsMobile] = useState(false);

  const mediaToMatch = '(max-width: 1365px)';
  useMatchMedia(setIsMobile, mediaToMatch);
  const page = parsePageData(data.datoCmsPage); // For Page component
  const feedByRelationship = parseFeedByRelationship(data); // For FeedByRelationship
  const { newsHighlight } = page.newsFeedModularBlock; // CardHero
  const { apiKey } = page.newsFeedModularBlock.model
    ? page.newsFeedModularBlock.model : {}; // To check the feed to mount
  const { defaultRelatedNews } = { defaultRelatedNews: data.allDatoCmsNews.nodes };
  const { slug } = data.datoCmsNewsArchive;
  const { newsNumber } = page.newsFeedModularBlock;
  const { titleFeed } = { titleFeed: page.newsFeedModularBlock.title };

  // FEATURE WHATSAPP
  // const [showWhatsapp, setShowWhatsapp] = useState(false);

  const currentPathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const dataIubenda = data.datoCmsCookieIubenda;
  const [showCookieIubendaToggle, setShowCookieIubendaToggle] = useState(false);

  const filteredRelatedNews = defaultRelatedNews.filter((news) => {
    // Filter all news different to the news in highlight
    if (!newsHighlight) return true;
    return news.slug !== newsHighlight.slug;
  });
  const cardHeroProps = {
    label: newsHighlight ? newsHighlight.topic.name : '',
    title: newsHighlight ? newsHighlight.title : '',
    labelButton: 'Scopri di più',
    image: (newsHighlight && newsHighlight.coverImage) ? newsHighlight.coverImage.fluid : '',
    alt: (newsHighlight && newsHighlight.coverImage) ? newsHighlight.coverImage.alt : '',
    url: newsHighlight ? `/${slug}/${newsHighlight.slug}` : ''
  };

  const feedProps = {
    title: 'home',
    url: slug,
    withHighlight: !!newsHighlight,
    labelLink: 'Vedi tutti',
    hasPadding: true,
    marginBottom: 'zero',
    marginTop: 'zero',
    hasBackground: true
  };

  const wrappedFeedProps = {
    feedProps,
    cardHeroProps,
    newsHighlight,
    newsFeedModularBlock: page.newsFeedModularBlock,
    defaultRelatedNews: filteredRelatedNews.slice(0, 9)
  };

  // FEATURE WHATSAPP
  // useEffect(() => {
  //   if (currentPathname.includes('younicef')) {
  //     setShowWhatsapp(true);
  //   } else {
  //     setShowWhatsapp(false);
  //   }
  // }, [currentPathname]);

  useEffect(() => {
    if (dataIubenda !== undefined && dataIubenda.showCookieIubenda === true && currentPathname.includes('cookie-policy')) {
      setShowCookieIubendaToggle(true);
    } else {
      setShowCookieIubendaToggle(false);
    }

    if (showCookieIubendaToggle) {
      const iubendaContainer = document.querySelector('.iubenda__container');
      if (iubendaContainer) {
        const iubendaScript = document.createElement('script');
        iubendaScript.type = 'text/javascript';
        iubendaScript.src = 'https://cdn.iubenda.com/iubenda.js';
        iubendaScript.textContent = `
        (function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);
      `;
        iubendaContainer.appendChild(iubendaScript);
      }
    }
  }, [currentPathname, showCookieIubendaToggle]);

  return (
    <Layout
      seoMetaTags={page.seoMetaTags}
      pathname={pageContext.pathname}
      communicationBar={pageContext.communicationBar}
      pageType="Page"
      canonical={pageContext.canonical}
    >
      <div className="page-template">
        <HeaderPage
          title={page.title}
          labelParent={page.treeParent}
          parentPathname={pageContext.parentPathname}
          isRoot={page.root}
          model={page.model}
          coverImage={page.coverImage}
          coverImageMobile={page.coverImageMobile}
          widgetCard={page.widgetCard}
        />
        <div className="page-wrapper">
          {
            page.widgetCard
            && isMobile
            && (
              <WidgetCard
                widgetCard={page.widgetCard}
              />
            )
          }
          <div className="page-wrapper__paragraph">
            <Paragraph
              subtitle={page.subtitle}
              content={page.content}
              contentAccordion={page.contentAccordion}
              marginTop="zero"
              marginBottom="zero"
              numCols={useSizeColsIsRoot(page.root)}
              root={page.root}
              pageSlug={page.slug}
              parentPathname={pageContext.parentPathname}
              treeParent={page.treeParent}
              treeChildren={page.treeChildren}
              activeNavigationSidebar
            />
            {showCookieIubendaToggle && (
              <div className="paragraph-content__wrapper">
                <div className="paragraph__container num-cols--large">
                  <div className="paragraph__wrapper">
                    <div className="iubenda__container"><a href="https://www.iubenda.com/privacy-policy/50247939/cookie-policy/section/other-types-cookies" className="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iub-legal-only iub-no-markup iubenda-noiframe iub-body-embed" title="Cookie Policy">Cookie Policy</a></div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {
            data && data.datoCmsPage && (
              <VisualComposer
                root={data.datoCmsPage.root}
                components={data.datoCmsPage.visualComposer}
              />
            )
          }
        </div>

        {apiKey === 'news_feed' && <FeedWithHighlight {...wrappedFeedProps} />}

        {apiKey === 'news_by_relationship' && feedByRelationship.list[0] && (
          <FeedByRelationship
            archiveSlug={slug}
            relatedNews={
              feedByRelationship.list.slice(0, newsNumber)
            }
            relatedNewsBy={feedByRelationship.relatedBy}
            news={feedByRelationship.sampleNews}
            titleFeed={titleFeed}
          />
        )}
      </div>
      {/* FEATURE WHATSAPP */}
      {/* {showWhatsapp && <a aria-label="Chat on WhatsApp" href="https://wa.me/1XXXXXXXXXX" target="_blank" rel="noreferrer" className="link-whatsapp"><Icon path="social-ico-whatsapp" /></a>} */}
    </Layout>
  );
};

export default PageTemplate;
